import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule, DecimalPipe } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CoreRoutesModule } from "./core.routes";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import {
  MatIconModule,
  MatMenuModule,
  MatProgressSpinnerModule
} from "@angular/material";
import { NgSelectModule } from "@ng-select/ng-select";

import {
  LayoutComponent,
  SidebarComponent,
  ForbiddenComponent,
  LoginComponent,
  DlvErrorComponent,
  LogoutComponent,
  SyncPermComponent,
  DlvCallbackComponent
} from "./components";
// import { NgxOrPermissionDirective } from "./../shared/directives/ngxOrPermissions.directive";
import { SharedModule } from "../shared/shared.module";

// import {
//   AuthGuardService,
//   LoaderService,
//   BroadcasterService
// } from "./services/";
import { DummyPageComponent } from "./components/dummy-page/dummy-page.component";
import { HighchartsChartModule } from "highcharts-angular";
import { DlvNgAuthModule } from 'dlv-ng-auth';

@NgModule({
  declarations: [
    LayoutComponent,
    SidebarComponent,
    ForbiddenComponent,
    LoginComponent,
    DlvErrorComponent,
    DummyPageComponent,
    LogoutComponent,
    SyncPermComponent,
    DlvCallbackComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DlvNgAuthModule,
    CoreRoutesModule,
    SharedModule,
    MatIconModule,
    TranslateModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    HighchartsChartModule,
    NgSelectModule
  ],
  entryComponents: [],
  providers: [DecimalPipe]
})
export class CoreModule {}
